<template>
  <div class="w-full md:w-1/3 p-2 justify-center text-center item">
    <h2 class="text-lg text-blue mb-4 block">
      {{ item.city }}
      <span class="font-normal">{{ item.name ? ' - ' + item.name :'' }}</span>
    </h2>
    <figure>
      <img :src="image" alt>
    </figure>
    <div class="text-xs">
      <p class="mb-1" v-if="item.address">{{ item.address }}</p>
      <p class="text-blue font-bold mb-1" v-if="item.phone">{{ item.phone }}</p>
      <p class="mb-1" v-if="item.email">{{ item.email }}</p>
      <p class="mb-1" v-if="item.schedule">{{ item.schedule }}</p>
    </div>

    <!-- <p v-if="item.address">{{ item.address }}</p> -->
  </div>
</template>

<script>
export default {
  name: "Item",
  props: ["item"],
  computed: {
    image() {
      return require("../assets/" + this.item.image);
    }
  }
};
</script>

<style scoped>
.item {
  height: 350px;
}
</style>
